import { UploadedPolicyGetUseCase } from '../../../application';

export default class UploadedPolicyGetService {
    constructor() {}

    async execute(event) {
        const request = await UploadedPolicyGetUseCase(event);

        return request;
    }
}
